import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Page} from "@indebted/components/Page"
import {PaymentCompletedImage} from "@indebted/assets"
import {Props, Prop, PropValue, PropLabel} from "@indebted/components/Props"
import {useTranslation} from "react-i18next"

import {useStatusPageData} from "./index"

export function CompletedPage() {
	const data = useStatusPageData()
	const {
		InstalmentAmountValue,
		InstalmentAmountCurrency,
		FrequencyValue,
		StartDateValue,
		EndDateValue,
		ClientName,
		CustomerName,
	} = data.data
	const {t} = useTranslation()
	const {i18n} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("payment_arrangement_status.completed.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" className="amp-mask">
					{t("payment_arrangement_status.completed.message", {CustomerName: CustomerName})}
				</Typography>
			</Grid>

			<GridImage>
				<PaymentCompletedImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">{t("payment_arrangement_status.completed.details.plan.label")}</PropLabel>
					<PropValue align="left">
						{t(`payment_arrangement_status.completed.details.plan.value.${FrequencyValue}`, {
							InstalmentAmount: InstalmentAmountValue / 100,
							formatParams: {
								InstalmentAmount: {
									currency: InstalmentAmountCurrency,
								},
							},
						})}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.completed.details.paid_to.label")}
					</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.completed.details.start_date.label")}
					</PropLabel>
					<PropValue align="left">
						{new Date(StartDateValue).toLocaleDateString(i18n.language, {
							year: "numeric",
							month: "long",
							day: "numeric",
						})}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.completed.details.end_date.label")}
					</PropLabel>
					<PropValue align="left">
						{new Date(EndDateValue).toLocaleDateString(i18n.language, {
							year: "numeric",
							month: "long",
							day: "numeric",
						})}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`
